export const GROUP_OPTIONS = [{ value: 'nhssaa', label: 'NHSSAA' }];
